import { useMemo } from 'react'
import { observer } from 'mobx-react-lite'
import { EnumDropdownItemVariant, type IDropdownItem } from 'shared/ui/Dropdown'
import { FilterDropdown } from 'shared/ui/TableNew/ui/FilterDropdown/FilterDropdown'
import { type IRowDefault, type ITableProps } from 'shared/ui/TableNew'

type ISimpleFilterDropdownProps<TRow extends IRowDefault> = {
  columns: ITableProps<TRow>['columns']
  visibleColumnsIds?: string[]
  setVisibleColumnsIds: (ids: string[]) => void
  noSearch?: boolean
}

export const SimpleFilterDropdown = observer(
  <TRow extends IRowDefault>({
    columns,
    visibleColumnsIds,
    setVisibleColumnsIds,
    noSearch,
  }: ISimpleFilterDropdownProps<TRow>) => {
    const filterDropdownGroups = useMemo(() => {
      return [
        {
          label: '',
          items: columns
            .reduce<IDropdownItem[]>((state, current) => {
              if (!current.isHideForManage) {
                state.push({
                  id: current.field,
                  label: current.fullName || current.name || '',
                  variant: EnumDropdownItemVariant.Checkbox,
                  activeValue: Boolean(visibleColumnsIds?.includes(current.field)),
                  isCardClick: true,
                  disabled: current.isDisabledChangeVisible,
                })
              }

              return state
            }, [])
            .filter(Boolean),
        },
      ]
    }, [columns, visibleColumnsIds])

    const onChangeItem = (item: IDropdownItem) => {
      if (visibleColumnsIds?.includes(String(item.id))) {
        setVisibleColumnsIds?.(visibleColumnsIds.filter((id) => id !== item.id))
      } else if (visibleColumnsIds) {
        setVisibleColumnsIds?.([...visibleColumnsIds, String(item.id)])
      }
    }

    return (
      <FilterDropdown
        filterDropdownGroups={filterDropdownGroups}
        changeActiveFields={onChangeItem}
        autoHeightMax={350}
        iconButtonProps={{
          transparentInactive: true,
          ariaLabel: 'SimpleFilterDropdown_manageColumns',
        }}
        placement='bottom-end'
        tooltipLabel='Manage columns'
        noSearch={noSearch}
        ariaLabel='Manage columns'
      />
    )
  }
)
